module.exports = __webpack_public_path__ + "img/Hypoxia-CRC_CRLM.99262a75.png";